import { postCall, getCall, putCall, setOrgId, org_id } from "./api";
import { getOrgDetails, setOrgDetails, invalidateLegalUnits } from "./globalData";

// The entity list drives the entity switcher and everything scoped by it, so
// adding or renaming one has to reach the cached copy. See department.js.
const invalidatingUnits = (res) => {
  if (res?.success !== false) invalidateLegalUnits();
  return res;
};

export const loginUser = async (token) => {
  const request = {
    firebaseToken: token,
    path: "/auth/login-firebase",
  };
  return await postCall(request);
};

export const registerUser = async (token, input = {}) => {
  const request = {
    firebaseToken: token,
    path: "/auth/register-user",
    bodyParams: input,
  };
  return await postCall(request);
};

export const verifyOTPForUser = async (token, otp) => {
  const request = {
    firebaseToken: token,
    path: "/auth/update-account",
    bodyParams: { otp },
  };
  return await postCall(request);
};

export const generateOTPForUser = async (token) => {
  const request = {
    firebaseToken: token,
    path: "/auth/recover-account",
  };
  return await postCall(request);
};

export const addLegalUnit = async (input = {}) => {
  const request = {
    path: "/legal-unit/",
    bodyParams: input,
  };
  return invalidatingUnits(await postCall(request));
};

export const getLegalUnit = async () => {
  const request = {
    path: "/legal-unit/",
  };
  return await getCall(request);
};

export const updateLegalUnit = async (id, input = {}) => {
  const request = {
    path: `/legal-unit/${id}`,
    bodyParams: input,
  };
  return invalidatingUnits(await putCall(request));
};

export const registerOrg = async (input = {}) => {
  const request = {
    path: "/organization",
    bodyParams: input,
  };
  return await postCall(request);
};

export const updateOrgDetails = async (input = {}) => {
  const orgDetails = getOrgDetails();
  const request = {
    path: "/organization",
    bodyParams: input,
  };
  return await postCall(request);
};

// This will change to login employee.
/**
 * Whether the caller's colleagues already use PayLoom.
 *
 * Answers for their own email domain only, and never for a free provider — so
 * it is silent for a personal address rather than claiming every Gmail user is
 * a colleague.
 */
/** Ask to be added to an organisation on my own email domain. */
export const requestToJoinOrg = async (organizationId) =>
  await postCall({ path: "/join-request", bodyParams: { organizationId } });

/** Requests waiting on this admin. */
export const getJoinRequests = async () => await getCall({ path: "/join-request" });

/** Approve or decline one. */
export const decideJoinRequest = async (id, approve, legalUnitId) =>
  await postCall({
    path: `/join-request/${id}/decide`,
    bodyParams: legalUnitId ? { approve, legalUnitId } : { approve },
  });

export const organizationsOnMyDomain = async () =>
  await getCall({ path: "/organization/on-my-domain" });

export const organizationLogin = async () => {
  try {
    const orgDetails = getOrgDetails();
    const { _id: org_id } = orgDetails || {};
    if (org_id) {
      setOrgId(org_id);
      const request = {
        path: `/auth/access-token/${org_id}`,
      };
      return await getCall(request, "OrgLogin");
    } else {
      console.log("organsisation not found, switch to login page");
      window.location.path = "/login";
    }
  } catch (e) {
    console.log(e);
    window.location.path = "/login";
  }
};
// const res = await axios.request(requestOptions);

export const addCompanyDetails = async (input = {}) => {
  const request = {
    path: "/organization",
    bodyParams: input,
  };
  const res = await postCall(request);
  const { success, data } = res;
  if (success && data) {
    const { organizations } = data;
    setOrgDetails(organizations);
  }
  return res;
};

export const selectPlans = async (input = {}) => {
  const request = {
    path: "/organization",
    bodyParams: input,
  };
  return await postCall(request);
};

// Marks the Select Plan (final onboarding) step complete on the backend so the
// dashboard gate (org.onboardingComplete) opens. Persists the chosen purpose.
export const completeOnboarding = async (orgId, purposeForOrg = []) => {
  const request = {
    path: "/organization/complete-onboarding",
    bodyParams: { orgId, purposeForOrg },
  };
  return await postCall(request);
};

export const createEmployee = async (input = {}) => {
  const request = {
    path: "/employee/self-onboarding",
    bodyParams: input,
  };
  return await postCall(request);
};

export const getEmployee = async (input = {}) => {
  const request = {
    path: "/employee",
  };
  return await getCall(request);
};
